namespace GeniuzPOS.PosShift {
    export interface PsVatRefundDtRow {
        Id?: number;
        DocNo?: string;
        RefInv?: string;
        RefTaxNo?: string;
        PluCode?: string;
        PluDesc?: string;
        ItemNo?: number;
        Qty?: number;
        Amt?: number;
        ItemVat?: number;
        ItemId?: number;
        Cancel?: number;
    }

    export namespace PsVatRefundDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PluDesc';
        export const localTextPrefix = 'PosShift.PsVatRefundDt';
        export const lookupKey = 'PsVatRefundDtRow';

        export function getLookup(): Q.Lookup<PsVatRefundDtRow> {
            return Q.getLookup<PsVatRefundDtRow>('PsVatRefundDtRow');
        }
        export const deletePermission = '1POSBASE:ใบกำกับภาษี:VatRefund:Modify';
        export const insertPermission = '1POSBASE:ใบกำกับภาษี:VatRefund:Modify';
        export const readPermission = '1POSBASE:ใบกำกับภาษี:VatRefund:View';
        export const updatePermission = '1POSBASE:ใบกำกับภาษี:VatRefund:Modify';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            RefInv = "RefInv",
            RefTaxNo = "RefTaxNo",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            ItemNo = "ItemNo",
            Qty = "Qty",
            Amt = "Amt",
            ItemVat = "ItemVat",
            ItemId = "ItemId",
            Cancel = "Cancel"
        }
    }
}
